import React from 'react';

const EnergyCertificateGradeF = props => (
  <svg width="217" height="33" viewBox="0 0 217 33" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M0 0.285786V32.7631H200.249L216.618 16.3978L200.249 0.285786H0Z" fill="#EB422C" />
    <path
      d="M177.843 29.7506H172.628V4.79085H190.393V9.20505H177.843V14.8374H188.829V19.2516H177.843V29.7506Z"
      fill="white"
    />
  </svg>
);

export default EnergyCertificateGradeF;
